import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';

/** 获取服务商事件首页汇总 */
export const getAgencyEventSummary = (data: any) => smb_fetch(
  getAgpApiUrl('crm_task_service/agency_event', 'get_summary'),
  { method: 'POST', contentType: 'application/json', data: data || {} },
  true, false,
);

/** 获取服务商事件列表 */
export const getAgencyEventList = (data?: any) => smb_fetch(
  getAgpApiUrl('crm_task_service/agency_event', 'get_list'),
  { method: 'POST', contentType: 'application/json', data },
  true, false,
);

/** 获取服务商事件详情 */
export const getAgencyEventDetail = (data?: any) => smb_fetch(
  getAgpApiUrl('crm_task_service/agency_event', 'get_detail'),
  { method: 'POST', contentType: 'application/json', data },
  true, false,
);

/** 提交服务商事件反馈 */
export const submitAgencyEventFeedback = (data?: any) => smb_fetch(
  getAgpApiUrl('crm_task_service/agency_event', 'submit_feedback'),
  {
    method: 'POST',
    contentType: 'application/json',
    data,
    loadingTip: '提交中...',
  },
  true, false,
);

/** 获取事件 schema 列表（引擎初始化） */
export const getAgencyEventSchemas = () => smb_fetch(
  getAgpApiUrl('crm_task_service/agency_event', 'get_schema_list'),
  { method: 'POST', contentType: 'application/json', data: {} },
  true, false,
);

/** 获取事件 schema 列表（引擎初始化） */
export const getAgencyEventOptions = () => smb_fetch(
  getAgpApiUrl('crm_task_service/agency_event', 'get_agency_event_options'),
  { method: 'POST', contentType: 'application/json', data: {} },
  false, false,
);
